module.exports = {
  countries: (Api) ->
    return Api.Country.query().$promise

  subject: ($stateParams, Api) ->
    Api.MonitoringSubjects.get(id: $stateParams.subjectId).$promise
}
